import { Layout } from 'antd';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import './PageLayout.less';

export type PageFooterProps = { footer?: React.ReactNode; title?: string };

const PageFooter = ({ footer, title }: PageFooterProps) => {
  const { t } = useTranslation();
  const { Footer } = Layout;
  return (
    <>
      {footer ? (
        <Footer>{footer}</Footer>
      ) : (
        <Footer className={'footer'}>
          <div className={'footer-content'}>
            <div>{title ?? t('portal.info.title')}</div>
            <div>©{new Date().getFullYear()} Imprivata, Inc. All rights reserved. </div>
            <div>
              <a
                href={'https://www.imprivata.com/data-processing-addendum'}
                target={'_blank'}
                rel="noreferrer"
              >
                Data Processing Addendum
              </a>{' '}
            </div>
          </div>
        </Footer>
      )}
    </>
  );
};

export default PageFooter;
